import { ParallaxData } from '../../../core/modules/Parallax/ParallaxController';
import { ObstacleNameValues } from '../entities/obstacle/Obstacle';

export const ThemeName = {
  FunStreet: 'funStreet',
  Scrapyard: 'scrapyard',
  CitySky: 'citysky',
  Docks: 'docks',
  FrozenStreet: 'frozenStreet'
} as const;
export type ThemeNameKeys = keyof typeof ThemeName;
export type ThemeNameValues = typeof ThemeName[ThemeNameKeys];

export const Weather = {
  Dry: 'dry',
  Snow: 'snow',
  Wind: 'wind',
  Rain: 'rain'
};
export type WeatherKeys = keyof typeof Weather;
export type WeatherValues = typeof Weather[WeatherKeys];

export interface Theme {
  id: ThemeNameValues;
  texture: string;
  isNight: boolean;
  isSky: boolean;
  weather: WeatherValues;
  roadDetails: RoadDetails;
  parallaxLayers: ParallaxData[];
}

export interface RoadDetails {
  laneCount: number;
  lanes: { [key: number]: LaneDetails };
  laneHeight: number;
  laneScale: number;
  laneVehicleScale: number;
  startPointX: number;
  startPointY: number;
  vehicleOffset: number;
  obstacleOffset: number;
  // endPointX: number;
  pavementY: number;
  pavementHeight: number;

  roadStartY: number;
  roadEndY: number;
}

export interface LaneDetails {
  laneY: number;
}

export interface LaneItemDetails {
  minLanesAtOnce: number;
  maxLanesAtOnce: number;
  /**
   * How much a position has to have changed by to start another spawn round.
   * Stops multiple rounds of spawning happening in the same location.
   * Effectively the min distance before the next set of potential items can
   * spawn. Spawns can be blank if there's nothing left to spawn.
   */
  antiRepeatSpawnDistance: number;
  minSpawnAheadDistance: number;
  maxSpawnAheadDistance: number;
  defaultMaxSpawned: number;
  defaultTimeBetweenSpawns: number;
  allowedObstacles: ObstacleNameValues[];
  obstacleConfiguration: Partial<Record<ObstacleNameValues, LaneItemConfig>>;
  boostConfiguration: LaneItemConfig;
}

export interface LaneItemConfig {
  maxSpawned: number;
  timeBetweenSpawns: number;
}
